import { useState } from 'react';
import { MainAdminLayout } from 'admin/layout/MainAdminLayout';
import { ModalContainer } from 'admin/containers/Questions/styled';
import { SampleDiv } from 'admin/components/CreateQuestionModal/styled';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { UsersTopBlock } from 'admin/components/Users/usersTopBlock';
import {
  MODAL_CONSTANTS,
  ACTIVE_TABS,
  SHOW_CONTENT_NUMBERS,
} from 'admin/utils/contants';
import { CreateUserModal } from 'admin/components/Users/CreateUserModal';
import { EditUserModal } from 'admin/components/Users/EditUserModal';
import { MainTable } from 'admin/components/Table';
import {
  UserData,
  CustomerData,
  UsersHeader,
  CustomersHeader,
} from 'admin/TableDatas/mockDatas';

export const AdminHome = () => {
  const [activeTab, setActiveTab] = useState(ACTIVE_TABS.SYSTEM_USERS);
  const [typeOfAction, setTypeOfAction] = useState('');
  const [data, setData] = useState(UserData);
  const [customerData, setCustomerData] = useState(CustomerData);
  const [changeData, setChangeData] = useState({});
  const [selectedItems, setSelectedItems] = useState(null);
  const [selected, setSelected] = useState(SHOW_CONTENT_NUMBERS[0].value);
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  const openCreateModal = (e) => {
    setTypeOfAction(e);
    setIsOpen((prev) => !prev);
  };

  return (
    <MainAdminLayout>
      {isOpen ? (
        <ModalContainer>
          <SampleDiv ref={ref}>
            {typeOfAction === MODAL_CONSTANTS.ADD_USER ? (
              <CreateUserModal
                setData={setData}
                setIsOpen={setIsOpen}
                setCustomerData={setCustomerData}
                activeTab={activeTab}
                _data={activeTab === ACTIVE_TABS.SYSTEM_USERS ? data : customerData}
              />
            ) : (
              <EditUserModal
                setChangeData={setChangeData}
                changeData={changeData}
                setIsOpen={setIsOpen}
              />
            )}
          </SampleDiv>
        </ModalContainer>
      ) : null}

      <UsersTopBlock
        activeTab={activeTab}
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        setActiveTab={setActiveTab}
        selected={+selected}
        setData={activeTab === ACTIVE_TABS.SYSTEM_USERS ? setData : setCustomerData}
        _data={activeTab === ACTIVE_TABS.SYSTEM_USERS ? data : customerData}
        setSelected={setSelected}
        openCreateModal={openCreateModal}
      />

      <MainTable
        selected={+selected}
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        setChangeData={setChangeData}
        setDelete={
          activeTab === ACTIVE_TABS.SYSTEM_USERS ? setData : setCustomerData
        }
        openCreateModal={openCreateModal}
        _data={activeTab === ACTIVE_TABS.SYSTEM_USERS ? data : customerData}
        headerData={
          activeTab === ACTIVE_TABS.SYSTEM_USERS ? UsersHeader : CustomersHeader
        }
        activeTab={activeTab}
      />
    </MainAdminLayout>
  );
};
